import React from 'react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer" id="legal">
      <div className="container">
        <p className="disclaimer">
          LeagueTools is not endorsed by Riot Games and does not reflect the views or opinions of Riot Games 
          or anyone officially involved in producing or managing Riot Games properties. Riot Games and all 
          associated properties are trademarks or registered trademarks of Riot Games, Inc
        </p>
      </div>
    </footer>
  );
};

export default Footer; 